import React from 'react'
import { useRouter } from 'next/router'
import { useModal } from '@common/GlobalModal'
import { ModalDialogContainer } from '@common/modal/ModalDialogContainer'
import { DialogTitle, DialogContent, DialogActions } from '@common/material'
import { Button } from '@common/material'
import { Text } from '@fundamentals'
import { localizedStrings } from '@core/strings'
import { isMobile } from 'react-device-detect'

const BriefingPromptModal: React.FC = () => {
  const { hideModal } = useModal()

  return (
    <ModalDialogContainer>
      <DialogTitle variant='h5'>
        {localizedStrings.checklistBriefingPromptTitle}
      </DialogTitle>
      <DialogContent>
        <Text
          dangerouslySetInnerHTML={{
            __html: localizedStrings.checklistBriefingPromptDescription,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={hideModal}>
          {localizedStrings.close}
        </Button>
      </DialogActions>
    </ModalDialogContainer>
  )
}

export const OpenBriefingPrompt: React.FC<{}> = () => {
  // People were getting confused because they were scanning the QR code for a checklist, but not the one for a briefing
  // This shows a modal asking if the route is for a checklist explaining that they should use the QR code for briefings instead
  const router = useRouter()
  const { showModal } = useModal()

  if (!isMobile) {
    return null
  }

  React.useEffect(() => {
    const redirect = router.query?.redirect as string
    const testRegexes = [
      /^\/organisations\/\d+\/projects\/\d+\/checklists\/\d+$/,
      /^\/organisations\/checklists\/\d+$/,
      // For future use: add permit regexes if we support permit briefings via QR code
    ]

    if (redirect && testRegexes.some((r) => r.test(redirect))) {
      showModal(<BriefingPromptModal />)
    }
  }, [])

  return null
}
